import { amount } from "../utils/text.utils";

export default {
  filters: {
    txtInAmt(raw) {
      return amount(raw);
    }
  }
}